// App.jsx
import React, { useEffect, useState } from "react";
import { initI18n } from "./i18n"; // Si vous avez une fonction d'initialisation exportée
import Routes from "./Routes";
import "./i18n"; // Import direct aussi

function App() {
  const [isI18nReady, setIsI18nReady] = useState(false);

  useEffect(() => {
    // Initialiser i18n
    const initializeI18n = async () => {
      try {
        // Si vous avez une fonction d'initialisation asynchrone
        if (typeof initI18n === "function") {
          await initI18n();
        }
        // Sinon, l'import direct './i18n' suffit
        
        setIsI18nReady(true);
      } catch (error) {
        console.error("Erreur d'initialisation i18n:", error);
        setIsI18nReady(true); // Continuer même en cas d'erreur
      }
    };

    initializeI18n();
  }, []);

  // Afficher un loader pendant le chargement
  if (!isI18nReady) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5"
      }}>
        <div style={{
          textAlign: "center",
          padding: "20px",
          borderRadius: "8px",
          backgroundColor: "white",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-3">Initialisation des langues...</p>
        </div>
      </div>
    );
  }

  return <Routes />;
}

export default App;